import { useState, useEffect } from "react";
import styled from "styled-components";

import LabelSection from "src/components/core/LabelSection";
import Button from "src/components/core/Button";

import EditIcon from "@mui/icons-material/Edit";

// import EditBannerDialog from "./EditBannerDialog";
import PopularSellerEditDialog from "./PopularSellerEditDialog";

import { useDialog } from "src/context/DialogContext";

import { getSellerListAdmin } from "src/api/seller";

import { Black, White, White01 } from "src/styles/color";
import { hexToRgba } from "src/common/color";

import Loading from "src/components/ui/Loading";

const S = {};

S.BoxWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: ${White};
  box-shadow: 0px 4px 20px ${hexToRgba(Black, 0.1)};
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
`;

S.BannerListBoxWrapper = styled.div`
  position: relative;
  padding: 24px;
  background-color: ${White01};
  border-radius: 16px;
  margin-top: 24px;
  width: 100%;
  min-height: 200px;
  overflow: hidden;
  overflow-x: auto;
`;

S.BannerListContainer = styled.div`
  width: fit-content;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 24px;
  margin: 0 auto;
`;

S.SellerLogoItem = styled.img`
  width: 160px;
  height: 80px;
  border-radius: 16px;
  background: ${White};
  object-fit: contain;
  cursor: pointer;
`;

const PopularSeller = () => {
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();

  const [sellers, setSellers] = useState([]);
  const [selectedSellers, setSelectedSellers] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [dataSearch] = useState({
    keyword: null,
    page: 0,
    page_size: 1000,
    status: "all",
  });

  const fetchPopularSellers = async () => {
    try {
      setIsLoading(true);
      const { data: result } = await getSellerListAdmin({
        ...dataSearch,
        page: 0,
      });

      const _sellers = result?.data?.rows;
      setSellers(_sellers);

      const _selectedSellers = _sellers.filter(
        (seller) => seller?.is_show_homepage
      );
      setSelectedSellers(_selectedSellers);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPopularSellers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <S.BoxWrapper>
      <LabelSection
        title="ร้านค้ายอดนิยม"
        actionMenu={() => (
          <Button
            startIcon={<EditIcon />}
            variant="secondary"
            size="large"
            sx={{
              minWidth: 200,
            }}
            onClick={() => {
              openDialog({
                type: "custom",
                customDialog: (
                  <PopularSellerEditDialog
                    initialValue={{
                      sellers,
                    }}
                    onClose={() => closeDialog()}
                    onSuccess={async () => {
                      closeAllDialogs();
                      await fetchPopularSellers();
                    }}
                  />
                ),
              });
            }}
          >
            แก้ไข
          </Button>
        )}
      >
        <S.BannerListBoxWrapper>
          {isLoading && <Loading appendToBody={true} width={75} height={75} />}
          <S.BannerListContainer>
            {selectedSellers.map((seller) => (
              <S.SellerLogoItem
                key={seller?._id}
                src={seller?.icon_homepage || seller?.profile_image}
                alt={seller?.brand_name}
              />
            ))}
          </S.BannerListContainer>
        </S.BannerListBoxWrapper>
      </LabelSection>
    </S.BoxWrapper>
  );
};

export default PopularSeller;
